// Dados que eu desejo manter em um estado global na aplicação, para que os outros compoenentes possam acessar

export default {
    series: []
}